import type {
  EditorialColumnsProps,
  EditorialColumnsFACE,
  NumbersItem,
  Alignment,
} from '../../types';
import { ModuleType } from '../../types';
import type { Logger } from '@feature-hub/logger';
import { groupComponents } from './utils';

export const transformCmsDataToProps = (
  content: EditorialColumnsFACE,
  logger?: Pick<Logger, 'error' | 'info'>,
): EditorialColumnsProps | null => {
  if (!content?.moduleContent) return null;
  const textModuleContent = content.moduleContent?.type as ModuleType.TEXT;
  const numberModuleContent = content.moduleContent?.type as ModuleType.NUMBERS;
  let props: EditorialColumnsProps;

  const textModeComponentsGroup = groupComponents({
    components: content.moduleContent?.components,
    type: textModuleContent,
  });

  if (content.moduleContent.type === ModuleType.TEXT) {
    if (!textModeComponentsGroup) {
      logger?.error('No text components');
      return null;
    }
    props = {
      theme: content.themeOption && content.themeOption.theme ? content.themeOption.theme : 'Dark',
      type: textModuleContent,
      components: textModeComponentsGroup,
      headingOption: content.headingOption,
      textAlignment: content.textAlignment,
      caeIdentifier: content.caeIdentifierOption,
      disclaimers: content?.disclaimersOption,
    };

    return props;
  }

  const numberModeComponentsGroup = groupComponents({
    components: content.moduleContent?.components,
    type: numberModuleContent,
  }) as NumbersItem[][] | null;

  if (!numberModeComponentsGroup) {
    logger?.error('No number components');

    return null;
  }

  props = {
    theme: content.themeOption && content.themeOption.theme ? content.themeOption.theme : 'Dark',
    type: numberModuleContent,
    components: numberModeComponentsGroup,
    textAlignment: content.textAlignment,
    alignmentNumbers: content.alignmentNumbers as Alignment,
    flexibleWidth: content.flexibleWidth,
    headingOption: content.headingOption,
    caeIdentifier: content.caeIdentifierOption,
    disclaimers: content.disclaimersOption,
  };

  logger?.info('>>>after', props);

  return props;
};
